export default (context, payload) => {
    const moduleId = context.getters.moduleId;
    const apiData = context.rootState.appState.data;
    const setAttribute = payload.oneLni.storeUtils.setAttribute;

    const today = new Date();

    // Options to ensure leading zeros for month and day
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    };

    // Format the date with the specified options
    const formattedDate = today.toLocaleDateString('en-US', options);

    // Set labels manually
    setAttribute(context, `${moduleId}_complaint-description_input-text`, 'labelText', apiData['complaint.describe.label']);
    setAttribute(context, `${moduleId}_complaint`, 'labelText', apiData['complaint.label']);
    setAttribute(context, `${moduleId}_complaint`, 'options', apiData['complaint.options']);
    setAttribute(context, `${moduleId}_start-date`, 'labelText', apiData['complaint.startDate.label']);
    setAttribute(context, `${moduleId}_end-date`, 'labelText', apiData['complaint.endDate.label']);
    setAttribute(context, `${moduleId}_end-date`, 'maxDate', formattedDate);
    setAttribute(context, `${moduleId}_description_input-text`, 'labelText', apiData['complaint.description.label']);
    setAttribute(context, `${moduleId}_outcome_input-text`, 'labelText', apiData['complaint.outcome.label']);

    context.commit(`${payload.sourceId}/ADD_TRACKED_ERRORS`, [
        `${moduleId}_complaint-description`,
        `${moduleId}_complaint`,
        `${moduleId}_description`,
        `${moduleId}_outcome`,
    ], {
        root: true,
    });
};